<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">403</h1>
            <h4 class="pt-3">{{ $t("errors.forbiddenaccess") }}</h4>
            <p class="text-muted">{{ $t("errors.requiredpermissions") }}</p>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import jwtMixin from '../../mixins/jwtMixin'

export default { name: 'Page403',
  mixins: [jwtMixin],
  created () {
    this.$i18n.locale = this.jwtLanguage()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/pages/Page403.vue